export default function CoordinateRequestOutlineIcon({
  width = 12,
  height = 12,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M8.97421 11.0332C8.70118 10.7602 8.54779 10.3899 8.54779 10.0037C8.54779 9.61761 8.70118 9.2473 8.97421 8.97427C9.24724 8.70124 9.61755 8.54785 10.0037 8.54785C10.3898 8.54785 10.7601 8.70124 11.0331 8.97427C11.3062 9.2473 11.4596 9.61761 11.4596 10.0037C11.4596 10.3899 11.3062 10.7602 11.0331 11.0332C10.7601 11.3062 10.3898 11.4596 10.0037 11.4596C9.61755 11.4596 9.24724 11.3062 8.97421 11.0332Z'
        stroke='currentColor'
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.0037 8.54756V4.42256C10.0037 3.77902 9.74803 3.16184 9.29298 2.70679C8.83793 2.25174 8.22075 1.99609 7.57721 1.99609H5.63603'
        stroke='currentColor'
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.09191 0.540527L5.63603 1.99641L7.09191 3.45229'
        stroke='currentColor'
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.966861 3.02587C0.693831 2.75284 0.540443 2.38253 0.540443 1.99641C0.540443 1.61029 0.693831 1.23998 0.966861 0.966945C1.23989 0.693914 1.6102 0.540527 1.99633 0.540527C2.38245 0.540527 2.75276 0.693914 3.02579 0.966945C3.29882 1.23998 3.45221 1.61029 3.45221 1.99641C3.45221 2.38253 3.29882 2.75284 3.02579 3.02587C2.75276 3.2989 2.38245 3.45229 1.99633 3.45229C1.6102 3.45229 1.23989 3.2989 0.966861 3.02587Z'
        stroke='currentColor'
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.99632 3.45215V7.57715C1.99632 8.22069 2.25197 8.83787 2.70702 9.29292C3.16207 9.74797 3.77925 10.0036 4.42279 10.0036H6.36397'
        stroke='currentColor'
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.90809 11.4596L6.36397 10.0037L4.90809 8.54785'
        stroke='currentColor'
        strokeWidth='0.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
